import { Flex, Skeleton } from "antd";
import { FC } from "react";

export const PageSkeleton: FC = () => (
  <Flex vertical align="center" style={{ padding: "48px 24px" }}>
    <Skeleton paragraph={{ rows: 3 }} style={{ maxWidth: 600 }} />
  </Flex>
);
